import { InstantCheckoutTrolleyItem } from 'server/controller/api/types';
import { TrolleyItem } from 'services/graphql/types';
import { OrderLine } from 'services/orderOrchestration/types';
import toMapByKey from 'utils/toMapByKey';

export function getInstantCheckoutTrolleyItems(
  previoustrolleyItems: TrolleyItem[] = [],
  currentOrderLines: OrderLine[] = [],
): InstantCheckoutTrolleyItem[] {
  const previousTrolleyItemsByLineNumber = toMapByKey(previoustrolleyItems, 'lineNumber');
  return currentOrderLines.map(currentOrderLine => {
    const previousTrolleyItem = previousTrolleyItemsByLineNumber[currentOrderLine.lineNumber];
    const realQuantityDelta =
      currentOrderLine.quantity.amount! - (previousTrolleyItem?.reservedQuantity || 0);

    return {
      lineNumber: currentOrderLine.lineNumber,
      totalPrice: currentOrderLine.price,
      quantity: currentOrderLine.quantity,
      quantityDelta: realQuantityDelta,
    };
  });
}
